import 'angular';

import {IAuthenticatedUserService} from "../types/ServiceTypes";
import * as approvalTypes from "./approvals-types";
import {DescribeApprovalIncludeTypes, DescribeApprovalOwnerSortTypes} from "./approvals-types";
import * as approvalServiceTypes from "./approvals-service-types";
import {DescribeApprovalsResponse} from "./approvals-service-types";
import {IApprovalUtils} from './ApprovalUtils';

angular.module('GorillaBoy.Approvals')
.factory('ApprovalService', [
    '$rootScope',
    '$http',
    '$log',
    '$q',
    'authenticatedUser',
    'EndpointService',
    'ApprovalUtils',
    '$timeout',
    function ApprovalService($rootScope: ng.IRootScopeService, $http: ng.IHttpService, $log: ng.ILogService, $q: ng.IQService, authenticatedUser: IAuthenticatedUserService, EndpointService: any, ApprovalUtils: IApprovalUtils, $timeout: ng.ITimeoutService) {
        let approvalService = {} as approvalTypes.ApprovalService;

        approvalService.CreateApproval = (title: string, discription: string, LevelConfigs: approvalTypes.ApprovalLevelConfig[]) => {
            let config =  { 
                Title: title,
                Description: discription,
                LevelConfigs: LevelConfigs.map(ApprovalUtils.approvalLevelConfig2ApprovalLevelConfigDTO)
            },
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals';
            return $http.post(serviceUrl, config);
        };

        approvalService.GetApproval = (approvalId: string) => {
            let config =  {},
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId;

            return $http.get(serviceUrl, config);
        };

        approvalService.UpdateApproval = (approvalId: string, OperationName: approvalTypes.ApprovalOperationName, updatedApprovalRequest: approvalServiceTypes.ApprovalRequestDTO) => {
            let config =  {},
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '?operation=' + OperationName;
            if (OperationName === approvalTypes.ApprovalOperationName.UPDATE) {
                config = updatedApprovalRequest;
            }
            return $http.put(serviceUrl, config);
        };

        approvalService.DescribeApprovalResources = (approvalId: string, marker: string, delegateApproverId) => {
            let config: any =  {},
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/resources';

            if (marker) {
                serviceUrl += ('?marker=' + marker);
            }

            if (delegateApproverId) {
                config.DelegateApproverId = delegateApproverId;
            }
            return $http.get(serviceUrl, config);
        }

        approvalService.CreateApprovalResources = (approvalId: string, resources: approvalTypes.ApprovalResource[]) => {
            let config =  {
                Resources: resources
            },
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/resources';
            
            return $http.post(serviceUrl, config);
        };

        approvalService.DeleteApprovalResources = (approvalId: string, resources: approvalTypes.ApprovalResource[]) => {
            let data =  {
                Resources: resources
            },
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/resources';
            return $http({
              method: 'DELETE',
              url: serviceUrl,
              data: data
            });
        };

        approvalService.CreateApprovers = (approvalId: string, approvers: approvalTypes.ApprovalApprover[]) => {
            let config =  {
                Approvers: approvers
            },
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/approvers';
            
            return $http.post(serviceUrl, config);
        };

        approvalService.DeleteApprovers = (approvalId: string, approvers: approvalTypes.ApprovalApprover[]) => {
            let data =  {
                Approvers: approvers
            },
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/approvers';
            return $http({
              method: 'DELETE',
              url: serviceUrl,
              data: data
            });
        }

        approvalService.DescribeApprovers = (approvalId: string, marker: string, delegateApproverId: string) => {
            let config: any =  {},
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/approvers';
            if (marker) {
                serviceUrl += ('?marker=' + marker);
            }

            if (delegateApproverId) {
                config.DelegateApproverId = delegateApproverId;
            }

            return $http.get(serviceUrl, config);
        };

        approvalService.DescribeApprovals = (include: DescribeApprovalIncludeTypes , sort: DescribeApprovalOwnerSortTypes,
                                             order: string,
                                             marker : string) => {
            let config: any =  {
                    params: {}
                },
                serviceUrl = SERVICE_ROOT() + '/api/v1/approvals';
            if (marker) {
                config.params.marker = marker;
            }
            if (include) {
                config.params.include = include;
            }
            if (sort) {
                config.params.sort = sort;
            }
            if (order) {
                config.params.order = order;
            }

            return $http.get(serviceUrl, config)
                .then(response => response.data) as ng.IPromise<DescribeApprovalsResponse>;
        };

        approvalService.DescribeAllApprovers = (approvalId: string, delegateApproverId: string) => {
            let approvers: approvalTypes.ApprovalApprover[] = [];
            let promise: ng.IPromise<approvalTypes.ApprovalApprover[]> = $q((resolve, reject) => {
                approvalService.DescribeApprovers(approvalId, null, delegateApproverId).then(describeApproversSucceededHandler);

                function describeApproversSucceededHandler(response: ng.IHttpPromiseCallbackArg<approvalServiceTypes.DescribeApproversResponse>) {
                    approvers = approvers.concat(response.data.Approvers);
                    if (response.data.Marker) {
                        approvalService.DescribeApprovers(approvalId, response.data.Marker, delegateApproverId).then(describeApproversSucceededHandler);
                    } else {
                        resolve(approvers);
                    }
                }
            });

            return promise;
        };

        approvalService.CreateApprovalAction = (approval: approvalTypes.ApprovalInfo, action: approvalTypes.ApprovalActionType, actionComment: string, delegateApproverId: string) => {
            let config: any =  {
                ApprovalLastModifiedDate: approval.ModificationDate,
                Action: approvalTypes.ApprovalActionType[action],
                Comment: actionComment
            },
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approval.Id + '/actions';

            if (delegateApproverId) {
                config.DelegateApproverId = delegateApproverId;
            }

            return $http.post(serviceUrl, config);
        };

        approvalService.DescribeApprovalActions = (approvalId: string, marker: string, delegateApproverId: string) => {
            let config: any =  {},
            serviceUrl = SERVICE_ROOT() + '/api/v1/approvals/' + approvalId + '/actions';

            if (marker) {
                serviceUrl += ('?marker=' + marker);
            }

            if (delegateApproverId) {
                config.DelegateApproverId = delegateApproverId;
            }

            return $http.get(serviceUrl, config);
        };

        approvalService.DescribeAllApprovalActions = (approvalId: string, delegateApproverId: string) => {
            let actions: approvalTypes.ApprovalAction[] = [];

            let promise: ng.IPromise<approvalTypes.ApprovalAction[]> = $q((resolve, reject) => {
                approvalService.DescribeApprovalActions(approvalId, null, delegateApproverId).then(describeApprovalActionsSucceededHandler);

                function describeApprovalActionsSucceededHandler(response: ng.IHttpPromiseCallbackArg<approvalServiceTypes.DescribeApprovalActionsResponse>) {
                    actions = actions.concat(response.data.ApprovalActions);
                    if (response.data.Marker) {
                        approvalService.DescribeApprovalActions(approvalId, response.data.Marker, delegateApproverId).then(describeApprovalActionsSucceededHandler);
                    } else {
                        resolve(actions);
                    }
                }
            });

            return promise;
        }

        function SERVICE_ROOT() {
            return EndpointService.wopiEndpoint();
        }

        return approvalService;
    }
]);